export const widgets = {}
